import React, { useEffect } from 'react';
import LoaderSpinner from 'components/LoaderSpinner/LoaderSpinner';
import { bool, string } from 'prop-types';
import styles from './Response.module.scss';

const Response = ({
  success,
  sendingMessage,
  successMessage,
  error,
  errorMessage,
}) => {
  useEffect(() => {}, []);

  return (
    <div className={styles.wrapper}>
      <div className={styles.wait}>
        {!error && <LoaderSpinner stop={success} />}
        {error && <LoaderSpinner error={error} stop={error} />}
      </div>
      <span className={styles.message}>
        {!success && !error && sendingMessage}
        {success && successMessage}
        {error && errorMessage}
      </span>
    </div>
  );
};

Response.propTypes = {
  success: bool.isRequired,
  sendingMessage: string.isRequired,
  successMessage: string.isRequired,
  error: bool,
  errorMessage: string,
};

Response.defaultProps = {
  error: false,
  errorMessage: 'Error',
};

export default Response;
